import { render, staticRenderFns } from "./ed-institution-calendar.component.vue?vue&type=template&id=5757df50&scoped=true&"
import script from "./ed-institution-calendar.component.ts?vue&type=script&lang=ts&"
export * from "./ed-institution-calendar.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-institution-calendar.component.scss?vue&type=style&index=0&id=5757df50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5757df50",
  null
  
)

export default component.exports